import {
	getDealerSitesTransportEligibleOptions,
	getSelectedTransport,
	getTransportDeliveryDetails,
	getTransportEligibleOptions,
	getV2SelectedTransport,
} from 'Services/api/delivery';

import { TRANSPORT_MESSAGE_CODES } from './consts';

export const { INCORRECT_DEALER, NO_TRANSPORT_ENTRY, NO_TRANSPORT_TYPE_SET, TRANSPORT_CANCELLED } =
	TRANSPORT_MESSAGE_CODES;

const fetchTransport = async (enquiry, user, shouldUseV2) => {
	try {
		const selectedTransport = shouldUseV2
			? await getV2SelectedTransport(enquiry, user)
			: await getSelectedTransport(enquiry, user);
		return { selectedTransport };
	} catch (err) {
		const message = err?.response?.data?.message;
		const isHandledError = [TRANSPORT_CANCELLED, INCORRECT_DEALER, NO_TRANSPORT_ENTRY, NO_TRANSPORT_TYPE_SET].includes(
			message,
		);

		return {
			isCancelled: message === TRANSPORT_CANCELLED,
			isIncorrectDealer: message === INCORRECT_DEALER,
			isUnhandledTransportError: !isHandledError,
			noTransportEntry: message === NO_TRANSPORT_ENTRY,
			noTransportTypeSet: message === NO_TRANSPORT_TYPE_SET,
			transportErrorMessage: message,
		};
	}
};

export const getTransportOptions = async (transport, enquiry, user) => {
	try {
		const transportOptions = await getTransportEligibleOptions(enquiry, user);
		return { transportOptions };
	} catch (err) {
		const message = err?.response?.data?.message;
		const isIncorrectDealer = transport?.isIncorrectDealer || message === INCORRECT_DEALER;

		return {
			isIncorrectDealer,
			isUnhandledTransportOptionsError: !isIncorrectDealer,
			transportOptionsErrorMessage: message,
		};
	}
};

export const getDealerSitesTransportOptions = async (transport, enquiry, user) => {
	try {
		const transportOptions = await getDealerSitesTransportEligibleOptions(enquiry, user);
		return { transportOptions };
	} catch (err) {
		const message = err?.response?.data?.message;
		const isIncorrectDealer = transport?.isIncorrectDealer || message === INCORRECT_DEALER;

		return {
			isIncorrectDealer,
			isUnhandledTransportOptionsError: !isIncorrectDealer,
			transportOptionsErrorMessage: message,
		};
	}
};

export const getTransport = async (enquiry, user, shouldUseV2) => {
	const transport = await fetchTransport(enquiry, user, shouldUseV2);
	const { noTransportEntry, noTransportTypeSet } = transport;

	if (noTransportEntry || noTransportTypeSet) {
		const { isIncorrectDealer, isUnhandledTransportOptionsError, transportOptions, transportOptionsErrorMessage } =
			await getTransportOptions(transport, enquiry, user);

		return {
			...transport,
			isIncorrectDealer,
			isUnhandledTransportOptionsError,
			transportOptions,
			transportOptionsErrorMessage,
		};
	}

	return transport;
};

export const getDealerSites = async (enquiry, user) => {
	const transport = await fetchTransport(enquiry, user);
	const { noTransportEntry, noTransportTypeSet } = transport;

	if (noTransportEntry || noTransportTypeSet) {
		const { isIncorrectDealer, isUnhandledTransportOptionsError, transportOptions, transportOptionsErrorMessage } =
			await getDealerSitesTransportOptions(transport, enquiry, user);

		return {
			...transport,
			isIncorrectDealer,
			isUnhandledTransportOptionsError,
			transportOptions,
			transportOptionsErrorMessage,
		};
	}

	return transport;
};

export const fetchDeliveryDetails = async (enquiry, user) => {
	try {
		const { data } = await getTransportDeliveryDetails(enquiry, user);
		return data;
	} catch (err) {
		const message = err?.response?.data?.message;

		return {
			deliveryDetailsErrorMessage: message,
		};
	}
};
